import { render } from "./TheWrapperPublic.vue?vue&type=template&id=051a670d&scoped=true"
import script from "./TheWrapperPublic.vue?vue&type=script&lang=js"
export * from "./TheWrapperPublic.vue?vue&type=script&lang=js"

import "./TheWrapperPublic.vue?vue&type=style&index=0&id=051a670d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-051a670d"]])

export default __exports__